/** Mensaje alineado con backend/constants/betaFeatures.js */
export const OCR_SCAN_BETA_MESSAGE =
  'El escaneo de comprobantes está pausado durante la beta. Cargá el gasto a mano; lo activamos pronto para todos.';

export function isOcrScanEnabledFlag(scanEnabled) {
  return scanEnabled === true;
}
